const localURL = "http://localhost:8080";
const devURL = "https://cvp-api-dev.musea2.azure.ext.gm.com";
const testURL = "https://cvp-api-tst.musea2.azure.ext.gm.com";
const prodURL = "https://cvp-api.musea2.azure.ext.gm.com";

const preProdAuth = {
  auth_client_id: "45e29ab2-739b-4164-824e-916be38a7d20",
  auth_scope: "api://cvp.dev.gm.com/.default",
  authority:
    "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d",
};

const prodAuth = {
  auth_client_id: "08742f01-8dc1-44fc-96ed-2e0b0146a15c",
  auth_scope: "api://cvp.gm.com/.default",
  authority:
    "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d",
};

const prodEnv = {
  url: prodURL,
  ...prodAuth,
};

const testEnv = {
  url: testURL,
  ...preProdAuth,
};

const devEnv = {
  url: devURL,
  ...preProdAuth,
};

const localEnv = {
  url: localURL,
  ...preProdAuth,
};

export const getEnv = () => {
  const url = window.location.origin;
  if (url.includes("dev")) {
    return devEnv;
  }
  if (url.includes("tst")) {
    return testEnv;
  }
  if (url.includes("local")) {
    return localEnv;
  }
  return prodEnv;
};
